function getDisplayName(Component) {
    return Component.displayName
        || Component.name
        || 'UnnamedComponent';
}

export {
    getDisplayName,
};

export default {
    getDisplayName,
};
